import { render, staticRenderFns } from "./GptTargetFace.vue?vue&type=template&id=11b2ed03&scoped=true"
import script from "./GptTargetFace.vue?vue&type=script&lang=js"
export * from "./GptTargetFace.vue?vue&type=script&lang=js"
import style0 from "./GptTargetFace.vue?vue&type=style&index=0&id=11b2ed03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b2ed03",
  null
  
)

export default component.exports